import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
} from "constants/FormatDataContanst";
import {
  TYPE_ACTION_WORKFLOW,
  TYPE_ADJUST_INVOICE,
} from "constants/IssueInvoiceConstant";
import { LINK_TYPE } from "constants/TaxDeductConstant";
import React from "react";

export const KyHieuMauHoaDonList = [
  { key: "VAT", value: "1", label: "1 - Hóa đơn GTGT", prefix: "T" },
  { key: "SALE", value: "2", label: "2 - Hóa đơn bán hàng", prefix: "T" },
];

export const invoiceTypeMode = {
  HAVE_CODE: "1",
  NONE_CODE: "0",
};

export const convertDate = (data, format = "") => {
  const type = typeof data;
  let date = null;
  if (type === "object") {
    if (format === "date") {
      let dateSet = new Date(data);
      let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        dateSet
      );
      let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        dateSet
      );
      let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        dateSet
      );

      date = `${ye}-${mo}-${da} 00:00:00`;
    } else {
      date = Math.round(new Date(data).getTime() / 1000);
    }
  } else {
    date = data;
  }
  return date;
};

export const tableFormateDate = (data, isSecond = false) => {
  if (new Date(Number(data)).toString() !== "Invalid Date") {
    if (isSecond) {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "numeric",
      }).format(data * 1000);
    } else {
      return Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(data * 1000);
    }
  }
  return "";
};

export const MODE_FORM = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
  CREATE_REPORT: "create_report",
};

export const MODE_TAX_DEDUCT_ACTION = {
  REPLACE: "REPLACE",
  ADJUST: "ADJUST",
  ADJUST_INCREASE: "ADJUST_1",
  ADJUST_DECREASE: "ADJUST_2",
  ADJUST_CHANGE_INFO: "ADJUST_3",
};

export const TYPE_ADJUST_TAX_DEDUCT = {
  INCREASE: 1,
  DECREASE: 2,
  CHANGE_INFO: 3,
};

export const getDateStartEndByRangeMonth = (monthStart, monthEnd, year) => {
  const dateStart = `01/${monthStart}/${year}`;
  const lastDateEnd = new Date(year, Number(monthEnd) + 1, 0).getDate();
  const dateEnd = `${lastDateEnd}/${monthEnd}/${year}`;
  return { dateStart, dateEnd };
};

export const COMMON_CONDITION_VISIBLE = {
  SEND_APPROVE: {
    approve_status: [APPROVE_STATUS_M],
    auth_status: [AUTH_STATUS_APPROVE],
  },
  REJECT: {
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_APPROVE],
  },
  APPROVE: {
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_APPROVE],
  },
  RELEASE: {
    approve_status: [APPROVE_STATUS_A],
    auth_status: [AUTH_STATUS_APPROVE],
  },
};

export const COMMON_CONDITION_VISIBLE_TAX_DEDUCT = {
  // START Luồng duyệt và phát hành CTKT (Không có trong đợt CTKT)
  SEND_APPROVE: {
    report_id: [null],
    approve_status: [APPROVE_STATUS_M],
    auth_status: [AUTH_STATUS_NEW],
  },
  REJECT: {
    report_id: [null],
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_NEW],
  },
  APPROVE: {
    report_id: [null],
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_NEW],
  },
  DELETE: {
    report_id: [null],
    auth_status: [AUTH_STATUS_NEW],
    approve_status: [APPROVE_STATUS_M],
  },
  EDIT: {
    report_id: [null],
    auth_status: [AUTH_STATUS_NEW],
    approve_status: [APPROVE_STATUS_M],
  },
  // END Luồng duyệt và phát hành CTKT (Không có trong đợt CTKT)
  // START Luồng duyệt và phát hành CTKT (Thay Thế / Điều Chỉnh) (Nằm trong đợt CTKT)
  SEND_APPROVE_FROM_IMPORT: {
    report_id: [],
    isHaveLinkType: ["TRUE"],
    approve_status: [APPROVE_STATUS_M],
    auth_status: [AUTH_STATUS_NEW],
    link_type: [LINK_TYPE.CHILD_ADJUST, LINK_TYPE.CHILD_REPLACE],
  },
  REJECT_FROM_IMPORT: {
    report_id: [],
    isHaveLinkType: ["TRUE"],
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_NEW],
    link_type: [LINK_TYPE.CHILD_ADJUST, LINK_TYPE.CHILD_REPLACE],
  },
  APPROVE_FROM_IMPORT: {
    report_id: [],
    isHaveLinkType: ["TRUE"],
    approve_status: [APPROVE_STATUS_P],
    auth_status: [AUTH_STATUS_NEW],
    link_type: [LINK_TYPE.CHILD_ADJUST, LINK_TYPE.CHILD_REPLACE],
  },
  DELETE_FROM_IMPORT: {
    report_id: [],
    isHaveLinkType: ["TRUE"],
    approve_status: [APPROVE_STATUS_M],
    auth_status: [AUTH_STATUS_NEW],
    link_type: [LINK_TYPE.CHILD_ADJUST, LINK_TYPE.CHILD_REPLACE],
  },
  EDIT_FROM_IMPORT: {
    report_id: [],
    isHaveLinkType: ["TRUE"],
    auth_status: [AUTH_STATUS_NEW],
    approve_status: [APPROVE_STATUS_M],
    link_type: [LINK_TYPE.CHILD_ADJUST, LINK_TYPE.CHILD_REPLACE],
  },
  // END Luồng duyệt và phát hành CTKT (Thay Thế / Điều Chỉnh) (Nằm trong đợt CTKT)

  REPLACE: {
    auth_status: [AUTH_STATUS_APPROVE],
    link_type: [3], //[LINK_TYPE.PARENT_REPLACE],
  },
  ADJUST: {
    auth_status: [AUTH_STATUS_APPROVE],
    link_type: [2], //[LINK_TYPE.PARENT_ADJUST],
  },
};

export const getTypeWorkflowMessage = typeMode => {
  let mess = "";
  switch (typeMode) {
    case TYPE_ACTION_WORKFLOW.SUBMIT:
      mess = "Gửi duyệt đợt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.APPROVE:
      mess = "Duyệt đợt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.REJECT:
      mess = "Từ chối duyệt đợt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.RELEASE:
      mess = "Phát hành đợt CTKT";
      break;
    default:
      break;
  }
  return mess;
};

export const getTypeWorkflowTaxDeductMessage = typeMode => {
  let mess = "";
  switch (typeMode) {
    case TYPE_ACTION_WORKFLOW.SUBMIT:
      mess = "Gửi duyệt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.APPROVE:
      mess = "Duyệt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.REJECT:
      mess = "Từ chối duyệt CTKT";
      break;
    case TYPE_ACTION_WORKFLOW.RELEASE:
      mess = "Phát hành CTKT";
      break;
    default:
      break;
  }
  return mess;
};

export const getRowTaxDeductReplaceAdjustInfo = (
  row,
  setDataCompare,
  dispatch,
  getDataLink,
  toggleCompareTaxDeductModal
) => {
  let info = null;
  let dataCompare = {
    leftInvoice: null,
    rightInvoice: null,
    ttctlquan_tcctu: null,
    typeChange: null,
  };
  let textInfo = "";
  let isChild = false;
  if (row.link_type || row.ttctlquan_lhctlquan === "3") {
    // $link_type Đánh dấu trạng thái liên kết điều chỉnh/thay thế 1 => parent replace , 2 => parent adjust , 3 => child replace , 4 => child adjust
    if (row.link_type) {
      switch (row.link_type) {
        // Parent
        case LINK_TYPE.PARENT_REPLACE:
          isChild = true;
          dataCompare.typeChange = " thay thế";
          break;
        case LINK_TYPE.PARENT_ADJUST:
          isChild = true;
          dataCompare.typeChange = " điều chỉnh";
          break;
        // Child
        case LINK_TYPE.CHILD_REPLACE:
          isChild = false;
          dataCompare.typeChange = " thay thế";
          break;
        case LINK_TYPE.CHILD_ADJUST:
          isChild = false;
          dataCompare.typeChange = " điều chỉnh";
          break;
        default:
          break;
      }
    }
    if (isChild) {
      dataCompare.leftInvoice = {
        current: "",
        id: row.id,
        msctu: row.ttchung_msctu,
        khctu: row.ttchung_khctu,
        sctu: row.ttchung_sctu,
        nlap: tableFormateDate(row.ttchung_nlap),
      };
      // dataCompare.rightInvoice = {
      //   id: child.id,
      //   msctu: child.ttchung_msctu,
      //   khctu: child.ttchung_khctu,
      //   sctu: child.ttchung_sctu,
      //   nlap: tableFormateDate(child.ttchung_nlap),
      // };
    }
    // ID của hóa đơn bị hóa đơn hiện tại thay thế/ điều chỉnh
    if (!isChild) {
      textInfo = " bị";
      // dataCompare.leftInvoice = {
      //   id: root.id,
      //   msctu: root.ttchung_msctu,
      //   khctu: root.ttchung_khctu,
      //   sctu: root.ttchung_sctu,
      //   nlap: tableFormateDate(root.ttchung_nlap),
      // };
      dataCompare.rightInvoice = [
        {
          current: "",
          id: row.id,
          msctu: row.ttchung_msctu,
          khctu: row.ttchung_khctu,
          sctu: row.ttchung_sctu,
          nlap: tableFormateDate(row.ttchung_nlap),
        },
      ];
    }
    if (row.ttctlquan_lhctlquan === "3") {
      // ID của hóa đơn thay thế/ điều chỉnh cho hóa đơn hiện tại
      dataCompare.ttctlquan_tcctu = row.ttctlquan_tcctu;
      let adjust_mod = null;
      let typeChange = " thay thế";
      if (dataCompare.ttctlquan_tcctu) {
        adjust_mod = row.adjust_mod;
      } else {
        adjust_mod = row.child.adjust_mod;
      }
      switch (adjust_mod) {
        case TYPE_ADJUST_INVOICE.INCREASE:
          typeChange = " điều chỉnh tăng";
          break;
        case TYPE_ADJUST_INVOICE.DECREASE:
          typeChange = " điều chỉnh giảm";
          break;
        case TYPE_ADJUST_INVOICE.CHANGE_INFO:
          typeChange = " điều chỉnh thông tin";
          break;
        default:
          break;
      }
      dataCompare.typeChange = typeChange;
      textInfo = " bị";
      dataCompare.leftInvoice = {
        id: null,
        current: " (Thông tư 32)",
        msctu: row.ttctlquan_khmsctclquan,
        khctu: row.ttctlquan_khctclquan,
        sctu: row.ttctlquan_sctclquan,
        nlap: tableFormateDate(row.ttctlquan_nlctclquan),
        gchu: row.ttctlquan_gchu,
      };
      dataCompare.rightInvoice = [
        {
          current: "",
          id: row.id,
          msctu: row.ttchung_msctu,
          khctu: row.ttchung_khctu,
          sctu: row.ttchung_sctu,
          nlap: tableFormateDate(row.ttchung_nlap),
        },
      ];
    }
    dataCompare.currentId = row.id;

    info = (
      <i
        style={{ cursor: "pointer" }}
        title={
          "Hiển thị thông tin chứng từ" + textInfo + dataCompare.typeChange
        }
        className="font-size-17 bx bx-info-circle text-info"
        onClick={() => {
          dataCompare.isChild = isChild;
          setDataCompare(dataCompare);
          toggleCompareTaxDeductModal();
        }}
      ></i>
    );
  }
  return info;
};

// Lấy ký hiệu chứng từ theo năm hiện tại
export const getCurrentKhctu = () => {
  const currentYear = new Date().getFullYear().toString().slice(-2);
  return `CT/${currentYear}E`;
};
